<template>
  <div class="ReactionsInPlayer">
    <d-react-btn
      ref="DReactBtn"
      :isMobileDevice="isMobileDevice"
      :isMobileFullscreen="isMobileFullscreen"
      :workflowId="workflowId"
    />
    <div
      class="ReactionsInPlayer__num"
      :class="{ 'ReactionsInPlayer__num--desktop': !getter_is_window_mode }"
      @click="showReactPopup = true"
    >
      {{ reactionsNumber }}
    </div>
    <d-all-react-popup
      v-if="showReactPopup"
      :isMobileFullscreen="isMobileFullscreen"
      @close-popup="showReactPopup = false"
    />
  </div>
</template>

<script>
import DReactBtn from "@/components/DWorkflowPlayer/info/btns/DReactBtn";
import DAllReactPopup from "@/components/DWorkflowPlayer/info/DAllReactPopup";
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  name: "ReactionsInPlayer",
  components: {
    DReactBtn,
    DAllReactPopup,
  },
  props: {
    workflowId: String,
    isMobileFullscreen: Boolean,
    isMobileDevice: Boolean,
  },
  async created() {
    this.storeReactionSet();
    // get reactions data if it's on iFrame
    if (this.workflowId !== this.reactionWorkflowId) {
      await this.fetchReactionsByWorkflowId({ workflowId: this.workflowId });
    }
  },
  data() {
    return {
      showReactPopup: false,
    };
  },
  methods: {
    ...mapActions("workflowReactions", ["storeReactionSet", "fetchReactionsByWorkflowId"]),
  },
  computed: {
    ...mapState("workflowReactions", ["reactionWorkflowId", "reactionsByWorkflow"]),
    ...mapGetters("workflowPlayer", ["getter_is_window_mode"]),
    reactionsNumber() {
      const num = this.reactionsByWorkflow.length || 0;
      if (num > 9) {
        return num;
      } else {
        return `0${num}`;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$smallPlayerMaxWidth: 1263px;
.ReactionsInPlayer {
  position: relative;
  display: flex;
  align-items: center;
  &__num {
    margin-left: 4px;
    padding: 2px 3px;
    color: white;
    font-size: 14px;
    line-height: 20px;
    cursor: pointer;
    &--desktop {
      font-size: 16px;
      @media screen and (max-width: $smallPlayerMaxWidth) {
        font-size: 14px;
      }
    }
  }
}
</style>
